// extracted by mini-css-extract-plugin
module.exports = {"value":"CharacterSheetModifier_value_1cdOA"};